<ion-text
  color="dark"
  innerHTML="{{
    '<h' + node?.level + '>' + node?.text + '</h' + node?.level + '>'
  }}"
>
</ion-text>
